import { AxiosResponse } from 'axios'
import { IRequisiteHistoryErrors } from './error.types'

export const getErrorResponse = <T>(error: unknown): T | null => {
  return isApiErrorResponse<T>(error) ? error.data.errors : null
}

const isApiErrorResponse = <T>(error: any): error is AxiosResponse<IRequisiteHistoryErrors<T>> => {
  return typeof error === 'object' && error !== null && error?.data?.errors
}

/**
 * Машиночитаемый код доменной ошибки (CPAYMENT-1591).
 *
 * Читаем из `error.data`, а НЕ из `error.response.data`: глобальный перехватчик
 * (`setupAxios` в `auth/core/AuthHelpers.ts`) реджектит сам `response`, поэтому `error.response`
 * в catch страницы всегда `undefined`. Обращение через `.response` тихо даёт `undefined`, и
 * страница показывает generic-фолбэк вместо текста по коду.
 */
export const getErrorCode = (error: unknown): string | undefined => {
  const data = (error as AxiosResponse | undefined)?.data
  const code = (data as { errorCode?: unknown } | undefined)?.errorCode

  return typeof code === 'string' ? code : undefined
}
